import axios from "axios";
import { userLogout } from "../utils/common";
import Config from "../utils/config";
let apiBasePath = "";
// let apiBasePath = "https://uat-apps.mufinpay.com";
// const apiBasePath = config.API_BASEPATH;
class Request {
  constructor(dispatch, successFn, errorFn) {
    this.successFn = typeof successFn === "function" ? successFn : () => { };
    this.errorFn = typeof errorFn === "function" ? errorFn : () => { };
    this.dispatch = typeof dispatch === "function" ? dispatch : () => { };
  }

  /**
   * GET axios instance and do things that are common for every request
   */
  instance() {
  const headers = {
    "X-Frame-Options": "SAMEORIGIN",
    "Content-Security-Policy": "default-src 'self'",
    "Strict-Transport-Security": "max-age=31536000",
    "X-Content-Type-Options": "nosniff",
    "Referrer-Policy": "no-referrer",
    "Permissions-Policy": "geolocation=()",
  };

  const instance = axios.create({
    baseURL: "",
    headers,
  });

  instance.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("authToken");

    const excludedApis = [
      "/user-service/admin/authenticate",
    ];

    const skipAuth = excludedApis.some((api) =>
      config.url.includes(api)
    );

    if (!skipAuth && token) {
      config.headers.Authorization = token;
    } else {
      delete config.headers.Authorization;
    }

    return config;
  });

  return instance;
}

  /**
   * GET Requests
   * @param {string} url
   * @param {object} params
   */
  async get(url, params = {}) {
    try {
      const res = await this.instance().get(apiBasePath + url, params);
      const data = res.data ? res.data : null;
      const headers = res.headers ? res.headers : null;
      this.successFn(data, headers);
      return res;
    } catch (error) {
      if (error && error.response && error.response.status === 401) {
        userLogout();
        window.location.href = "/admin";
      }

      this.errorFn(error);
    }
  }

  /**
   * POST Requests
   * @param {string} url
   * @param {object} params
   * @param {object} config
   */
  // async post(url, params = {}) {
  //   try {
  //     const res = await this.instance().post(apiBasePath + url, params);
  //     const { data = {}, status } = res;
  //     this.successFn(data, status);
  //     return res;
  //   } catch (error) {
  //     const responseData = error?.response?.data;
  //     const responseStatus = error?.response?.status;

  //     if (error && error.response && error.response.status == "401") {
  //       // need to check the status code for making user logout
  //       userLogout();
  //     }
  //     this.errorFn({
  //       response: {
  //         data: responseData,
  //         status: responseStatus,
  //       },
  //       message: error.message,
  //     });
  //     //   this.errorFn(data, status);
  //   }
  // }
  async post(url, params = {}, config = {}) {
    try {
      const res = await this.instance().post(apiBasePath + url, params, config);
      const contentType = res.headers?.["content-type"] || "";
      const data = res.data;
      const isHtml =
        typeof data === "string" &&
        data.trim().startsWith("<");
      if (!contentType.includes("application/json") || isHtml) {
        console.error("Non JSON / HTML response received", data);
        return;
      }
      const { status } = res;
      this.successFn(data || {}, status);
      return res;
    } catch (error) {
      const response = error?.response;
      const contentType = response?.headers?.["content-type"] || "";
      const responseData = response?.data;
      const isHtml =
        typeof responseData === "string" &&
        responseData.trim().startsWith("<");
      if (!contentType.includes("application/json") || isHtml) {
        console.error("HTML error response received", responseData);
        return;
      }
      const responseStatus = error?.response?.status;
      if (error && error.response && responseStatus === 401) {
        userLogout();
      }
      this.errorFn({
        response: {
          data: responseData,
          status: responseStatus,
        },
        message: error.message,
      });
    }
  }

  /**
   * PUT Requests
   * @param {string} url
   * @param {object} params
   */
  async put(url, params = {}) {
    try {
      const res = await this.instance().put(apiBasePath + url, params);
      const { data = {}, status } = res;
      this.successFn(data, status);
      return res;
    } catch (error) {
      if (error && error.response && error.response.status == "401") {
        userLogout();
      }
      if (
        url.startsWith(Config.apis.user.UPDATE_USER_MCC_CODE) &&
        error &&
        error.response &&
        error.response.status == "404"
      ) {
        this.errorFn(error.response.data);
        return;
      }

      this.errorFn(error);
    }
  }

  /**
   * DELETE Requests
   * @param {string} url
   * @param {object} params
   */
  async delete(url, params = {}) {
    try {
      const res = await this.instance().delete(apiBasePath + url, params);
      const { data = {}, status } = res;
      this.successFn(data, status);
      return res;
    } catch (error) {
      this.errorFn(error);
    }
  }

  /**
   * POST Requests (Login - passes full response)
   * @param {string} url
   * @param {object} params
   */
  async postLogin(url, params = {}) {
    try {
      const res = await this.instance().post(apiBasePath + url, params);
      const { data = {}, status } = res;

      this.successFn(res, status);
      return res;
    } catch (error) {
      if (error && error.response && error.response.status == "401") {
        userLogout();
      }

      this.errorFn(error);
    }
  }

  async getWithPayload(url, data = {}) {
    try {
      const res = await this.instance().get(apiBasePath + url, { data: data });

      const resData = res.data ? res.data : null;
      const headers = res.headers ? res.headers : null;

      this.successFn(resData, headers);
      return res;
    } catch (error) {
      if (error && error.response && error.response.status === 401) {
        userLogout();
        window.location.href = "/admin";
      }
      this.errorFn(error);
    }
  }

  /**
   * UPLOAD (multipart/form-data) - uses instance() headers (incl. auth)
   * @param {string} url
   * @param {FormData} formData
   */
  async upload(url, formData = new FormData()) {
    let alreadyHandled = false; // <--- flag to avoid double-calling errorFn

    try {
      const instance = this.instance();

      // Ensure Content-Type isn't pre-set so axios sets boundary
      if (instance.defaults && instance.defaults.headers) {
        delete instance.defaults.headers["Content-Type"];
      }

      const res = await instance.post(apiBasePath + url, formData);
      const { data = {}, status } = res;

      // Heuristic: treat as success when status is 2xx and body doesn't explicitly indicate failure
      const explicitFailure =
        data &&
        typeof data === "object" &&
        ((data.code && data.code !== "0000") ||
          (data.status && data.status !== 200) ||
          data.success === false ||
          data.error ||
          data.errors ||
          data.failed);

      const isStatus2xx = status >= 200 && status < 300;

      if (!isStatus2xx || explicitFailure) {
        const errObj = {
          response: { data, status },
          message: data?.msg || data?.message || "API reported failure during upload",
        };

        // call errorFn once
        alreadyHandled = true;
        this.errorFn(errObj);

        // throw with a marker so catch can know it was already handled
        const err = new Error(errObj.message);
        err.response = errObj.response;
        err.__handledByRequest = true;
        throw err;
      }

      // Success path
      this.successFn(data, status);
      return res;
    } catch (error) {
      // If axios/network threw, normalize; but DO NOT call errorFn again if we already did.
      const responseData = error?.response?.data;
      const responseStatus = error?.response?.status;

      // If error was already handled above, rethrow (or return) without calling errorFn again
      if (error && error.__handledByRequest) {
        throw error;
      }

      // handle 401 consistently
      if (responseStatus === 401) {
        userLogout();
        window.location.href = "/admin";
      }

      const errPayload = {
        response: {
          data: responseData,
          status: responseStatus,
        },
        message: error?.message || "Upload failed",
      };

      // Avoid double-calling: only call errorFn here if it wasn't called above
      if (!alreadyHandled) {
        this.errorFn(errPayload);
      }

      const errToThrow = new Error(errPayload.message);
      errToThrow.response = errPayload.response;
      throw errToThrow;
    }
  }
}

export default Request;